import { Injectable } from "@angular/core";
import { LocalStorageService } from '@library/utils/services/local-storage.service';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, delay, first, iif, mergeMap, of } from "rxjs";
import { DefaultLanguage, getCrowdinCode } from 'src/assets/supportedLangs';

const FeedbackPopupLocalStorageKey = 'feedback-popup-3-closed';

@Injectable()
export class FeedbackPopupService {

  private showFeedBackPopupSubject = new BehaviorSubject<boolean>(false);
  public showFeedBackPopup$ = this.showFeedBackPopupSubject.asObservable();

  get language() {
    const feedbackSupportedLanguages = ['en', 'fr', 'de', 'it', 'es-ES', 'nl'];
    const code = this.cookieService.get('netatmocomlocale');
    const language = getCrowdinCode(code);
    return feedbackSupportedLanguages.includes(language)
      ? language
      : DefaultLanguage;
  }

  get feedbackUrl() {
    let url = 'https://form.typeform.com/to/';
    switch (this.language) {
      case 'fr':
        url += 'ylbcFSRk';
        break;
      case 'de':
        url += 'TijHshoe';
        break;
      case 'it':
        url += 'c4Gfwyub';
        break;
      case 'es-ES':
        url += 'vQVdnVVf';
        break;
      case 'nl':
        url += 'OA1YoIuo';
        break;
      default:
        url += 'O8Soh0JC';
        break;
    }
    return url;
  }

  constructor(
    private localStorage: LocalStorageService,
    private cookieService: CookieService,
  ) {}

  public initFeedbackPopup(activeRoute: string) {
    // Start by conditionally showing the feedback popup with a delay
    of(true)
      .pipe(
        mergeMap(() =>
          iif(
            () => {
              const seenFeedbackPopup = !!this.localStorage.getItem(FeedbackPopupLocalStorageKey);
              const seenFUSControlPage = !!this.localStorage.getItem('control-fus-seen');
              const seenFUSComparePage = !!this.localStorage.getItem('control-fus-seen-compare');

              if (activeRoute.includes('compare')) {
                return !seenFeedbackPopup && seenFUSComparePage;
              }
              return !seenFeedbackPopup && seenFUSControlPage;
            },
            of(true).pipe(delay(180000)),
            of(false)
          )
        ),
        first()
      )
      .subscribe(result => {
        this.showFeedBackPopupSubject.next(result);
      });

  }

  public closeFeedbackPopup() {
    this.localStorage.setItem(FeedbackPopupLocalStorageKey, 'true');
    this.showFeedBackPopupSubject.next(false);
  }

}
